import { getData } from '../models/leagues/api';
import { useQuery } from 'react-query';

export const useLeague = (args) => {
  return useQuery(
    ['useLeague', args],
    async () => getData(args).then((result) => result.data![0]),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
      enabled: !!args,
    }
  );
};
